// extracted by mini-css-extract-plugin
export default {"wrapper":"SideBar_wrapper__R0b0f","wrapper-item":"SideBar_wrapper-item__U9ZeP","active":"SideBar_active__AMmaV","item-bar":"SideBar_item-bar__PyNvs","title":"SideBar_title__-JmQB"};